import { Controller } from "@hotwired/stimulus";

type DemoResponseEvent = CustomEvent<{ xhr: XMLHttpRequest }>;

export default class extends Controller<HTMLElement> {
    private mailbox: Window | null = null;

    open(event: Event): void {
        // Reserve the tab during the click, before the asynchronous login response.
        this.mailbox = window.open("about:blank", "_blank");
        if (!this.mailbox) {
            event.preventDefault();
            window.alert("Autorisez l’ouverture d’un nouvel onglet pour afficher la boîte de démonstration.");
            return;
        }
        this.mailbox.opener = null;
        this.mailbox.document.title = "Ouverture de la boîte de démonstration…";
    }

    complete(event: DemoResponseEvent): void {
        const url = event.detail.xhr.getResponseHeader("X-Elron-Demo-Mailbox");
        if (event.detail.xhr.status === 200 && url && this.mailbox) {
            this.mailbox.location.replace(url);
            this.mailbox = null;
        } else {
            this.close();
        }
    }

    close(): void {
        this.mailbox?.close();
        this.mailbox = null;
    }
}
